import React from 'react';
import { Price, PriceContainer } from '../../components/redesignComponents/ResultPageComponents/v2/QuotationCard.styles';

function PriceComponent({ quote }) {
  return (
    <PriceContainer>
      <Price>
        <h5>Prezzo annuo:</h5>
        {quote.amount_before_discount !== null
          && parseFloat(quote.amount_before_discount)
          > parseFloat(quote.amount) && (
            <p>
              &euro;
              {Number(quote.amount_before_discount).toLocaleString('it-IT', {
                minimumFractionDigits: 2,
              })}
            </p>
        )}
        <h2>
          &euro;
          {parseFloat(quote.amount).toFixed(2)}
        </h2>
      </Price>
      {quote.payment_frequency === 2 && (
        <Price>
          <h5>Prezzo Semestrale:</h5>
          <h6>Primo Pagamento</h6>
          <h2>
            &euro;
            {(Number(quote.amount) / quote.payment_frequency).toLocaleString(
              'it-IT',
              {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              },
            )}
          </h2>
        </Price>
      )}
    </PriceContainer>
  );
}

export default PriceComponent;
